<template>
  <div style="padding-left: 15px; margin-top: 15px;" class="tab-pane tab-pane--estimates col-12 active" :class="{ 'schedule-body-dragging': isBodyDragging }">
    <!-- Toggle view based on whether a schedule is selected -->
    <div v-if="!selectedSchedule" class="row no-gutter">
      <div class="col-sm-8">
        <div>
          <div class="card">
            <div class="card-header bg-navyblue">
              <strong>Schedule Management</strong>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between" style="padding: 8px 0">
          <div class="search-filter-schedule d-flex">
            <i class="bx bx-search-alt mr-0-5"></i>
            <input v-model="scheduleLineSearch"
                   style="padding-left: 0px !important; width: 100%; z-index: 999999; text-transform: uppercase;"
                   class="search-filter search-filter-schedule-management"
                   :placeholder="''">
          </div>
          <div @click="createNewSchedule" class="btn btn-primary plus-btn-hover">
            <i class="ti-plus"></i> New Schedule
          </div>
        </div>
        <div>
          <div class="card">
            <div class="schedule-table" style="overflow-y: hidden; height: 100%">
              <div class="schedule-table-header">
                <div class="schedule-table-header-item schedule-header-category" style="padding-left: 15px;">
                  Name
                </div>
                <div class="schedule-table-header-item schedule-header-line">
                  Type
                </div>
                <!--                <div class="schedule-table-header-item schedule-header-trush">-->
                <!--                </div>-->
              </div>
              <div class="schedule-table-body">
                <div @keydown="handleNavigation">
                  <!-- Iterate over the 'schedules' array fetched from the backend -->
                  <div v-for="(schedule, index) in filteredSchedules" :key="schedule.id || index">
                    <div class="schedule-table-body-elem">
                      <div class="schedule-table-body-item schedule-body-category">
                        <!-- Input is readonly if schedule.id < 0 -->
                        <input
                            :ref="'name-' + index"
                            v-model="schedule.name"
                            class="noselect form-control"
                            type="text"
                            :readonly="(schedule.id < 0)"
                            data-col="1"
                            :data-row="index"
                            @change="editSchedule(schedule)"
                        />
                      </div>
                      <div class="schedule-table-body-item schedule-body-line">
                        {{ (schedule.id < 0) ? 'Managed - RS' : 'Self - Managed' }}
                      </div>
                      <div class="schedule-table-body-item schedule-body-trush d-flex" style="width: 90px;">
                        <!-- Show edit and delete actions only for editable schedules (id >= 0) -->
                        <template v-if="schedule.id > 0">
                          <i @click="openSchedule(schedule)" class="bx bx-edit-alt"
                             style="font-size: 19px; margin-top: 5px; margin-right: 10px; color: #3f64a8; cursor: pointer;"></i>
                          <a @click="removeSchedule(schedule)" class="nav-link btn_trush"
                             style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row no-gutter">
      <div class="col-sm-12">
        <div>
          <div class="card">
            <div class="card-header bg-navyblue justify-content-between">
              <div>
                <button @click="selectedSchedule = null" class="btn btn-secondary btn-sm btn-back">
                  <i class='bx bx-arrow-back'></i>
                  Back
                </button>
                <strong style="position: relative; bottom: 6px">Schedule Management - {{
                    selectedSchedule.name
                  }}</strong>
              </div>
              <div class="schedule-management-actions">
                <div class="schedule-management-select">
                  <multiselect v-model="selectedScheduleTemplate"
                               :options="scheduleTemplateOptions"
                               :showLabels="false"
                               :allow-empty="false"
                               :searchable="false"
                               :internal-search="false"
                               :close-on-select="true"
                               :clear-on-select="false"
                               :preserve-search="true"
                               :custom-label="opt => opt.toUpperCase()"
                               @select="onTemplateSelect"
                               placeholder="">
                  </multiselect>
                </div>
                <button @click="exportScheduleCsv" type="button" class="btn tab-header-orders schedule-action-btn">
                  Export
                </button>
                <button @click="showCsvDropzone = !showCsvDropzone" type="button"
                        class="btn tab-header-orders schedule-action-btn">
                  Import
                </button>
              </div>
            </div>
          </div>
          <div class="vue-dropzone-block">
            <vue-dropzone v-if="showCsvDropzone" v-on:vdropzone-file-added="addFileUpload"
                          v-on:vdropzone-complete="completeFileUpload" v-on:vdropzone-sending="sendFileUpload"
                          v-on:vdropzone-processing="processingFileUpload"
                          v-on:vdropzone-success="successFileUpload" ref="fileUpDrop" id="fileUploadDrop"
                          class="dropify-wrapper dropzoneContainer" style="height: auto;"
                          :options="dropzoneOptions" :useCustomSlot=true>
              <div class="dropify-message" style="transform: translateY(0%);">
                <i class='bx bx-cloud-upload'></i>
                <p class="dnd-title">Select and add XLSX to Import</p>
                <p class="text-or mb-0-5 dnd-or">Or</p>
                <div class="text-sm-center mb-1 ex-image-upload-buttons">
                  <button type="button" class="btn btn-primary waves-effect waves-light browse-btn browse-btn-files">
                    Browse
                  </button>
                  <button @click="clickCancelDropzoneFiles" type="button"
                          class="btn btn-secondary waves-effect waves-light cancel-btn">Cancel
                  </button>
                </div>
              </div>
            </vue-dropzone>
          </div>
        </div>
        <div>
          <div class="schedule-management-toolbar">
            <div class="tabs-component tabs-component-2 schedule-management-tabs-component"
                 style="padding-top: 0px; position: static">
              <div v-for="tab in scheduleTabs" :key="tab" class="tabs-component-w">
                <ul class="nav nav-tabs nav-tabs-2 float-sm-left schedule-management-nav-tabs"
                    style="padding-left: 0; padding-right: 0" @click="activeScheduleTab = tab">
                  <li style="padding-top: 0px" class="tabs-component-tab nav-item">
                    <span href="" class="tabs-component-tab-a nav-link" :class="{ active: activeScheduleTab === tab }">
                      {{ tab }}
                    </span>
                  </li>
                </ul>
              </div>
              <div style="float: right; position: relative; top: 5px; width: 300px">
                <search-filter2 v-model="scheduleLineSearch" class="search-filter" :placeholder="''"></search-filter2>
              </div>
            </div>
          </div>
          <div v-if="activeScheduleTab == 'Body Section'" class="card">
            <div class="d-flex" style="align-items: flex-start;">
              <!-- Left Sidebar (Native Styled) -->
              <div>
                <div class="schedule-table-header">
                  <div class="schedule-table-header-item ">
                    Category Name
                  </div>
                </div>
                <!-- Replacing the old sidebar layout with the modern design -->
                <div class="category-sidebar">
                  <div class="category-list-container">
                    <div class="category-search-wrapper">
                      <input
                          v-model="bodyCategorySearch"
                          type="text"
                          class="category-search-input"
                          placeholder="Search">
                      <i class="bx bx-search-alt mr-0-5"></i>
                    </div>

                    <ul class="category-list vh-height-65">
                      <li v-for="category in filteredBodyScheduleCategories"
                          :key="category"
                          :class="['category-item', { 'active': activeBodyCategory === category }]">
                        <a href="#" @click.prevent="selectCategory(category, 'body')" class="category-link">
                          <span class="category-name">{{ category }}</span>
                          <i class="fa fa-angle-right category-arrow"></i>
                        </a>
                      </li>

                      <li v-if="isAddingBodyCategory" class="category-item">
                        <input
                            ref="newBodyCategoryInput"
                            v-model.trim="newBodyCategoryName"
                            type="text"
                            class="add-category-input"
                            placeholder="Enter category name"
                            @keydown.enter.prevent="saveCategory"
                            @keydown.esc.prevent="cancelAddCategory"
                            @blur="saveCategory">
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- Right Table Area -->
              <div class="schedule-table schedule-body-table">
                <div class="schedule-table-header">
                  <div class="schedule-table-header-item schedule-header-line">
                    Line Name
                  </div>
                  <div class="schedule-table-header-item schedule-header-code">
                    Code
                  </div>
                  <div class="schedule-table-header-item schedule-header-rr">
                    RR
                  </div>
                  <div class="schedule-table-header-item schedule-header-repair">
                    REPAIR
                  </div>
                  <div class="schedule-table-header-item schedule-header-paint">
                    PAINT
                  </div>
                  <div class="schedule-table-header-item schedule-header-trush">
                  </div>
                </div>

                <!-- Replace lines ~221-283: draggable for Body Section rows -->
                <div class="schedule-table-body">
                  <div @keydown="handleNavigation">
                    <draggable
                        v-if="bodyScheduleLines.length && !normalizedScheduleLineSearch"
                        :list="bodyScheduleLinesSource"
                        class="dragArea"
                        tag="div"
                        handle=".schedule-drag-handle"
                        ghost-class="ghost-items"
                        :options="{
                          animation: 150,
                          scroll: true,
                          scrollSensitivity: 150,
                          scrollSpeed: 15,
                          bubbleScroll: true,
                          forceFallback: true,
                          filter: '.numeric, input, .btn_trush, .btn_trush *',
                          preventOnFilter: false
                        }"
                        @start="onBodyLinesDragStart"
                        @end="onScheduleLinesDragEnd('body', bodyScheduleLinesSource)"
                    >
                      <div v-for="(part, index) in bodyScheduleLinesSource" :key="part._localId || part.id || index">
                        <div class="schedule-table-body-elem">
                          <div class="schedule-table-body-item schedule-drag-handle"
                               style="width: 24px; min-width: 24px; display: flex; align-items: center; justify-content: center;">
                            <i class='bx bx-dots-vertical-rounded'></i>
                          </div>
                          <div class="schedule-table-body-item schedule-body-line">
                            <input :ref="'line-' + index" v-model="part.name" class="noselect form-control" type="text"
                                   data-col="1" :data-row="index"
                                   @change="queueScheduleLineUpdate(part, 'body')">
                          </div>

                          <div class="schedule-table-body-item schedule-body-code">
                            <input :ref="'code-' + index"
                                   v-model="part.code"
                                   :data-row="index"
                                   class="noselect form-control"
                                   type="text"
                                   data-col="2"
                                   @change="queueScheduleLineUpdate(part, 'body')">
                          </div>

                          <div class="schedule-table-body-item schedule-body-rr">
                            <number-formatter :key="'rr-' + index + '-' + selectedScheduleTemplate"
                                              :ref="'rr-' + index"
                                              type="text"
                                              v-model="part.priceRR"
                                              :value="part.priceRR === 0 ? '' : part.priceRR"
                                              :isCanBeZero="false"
                                              class="noselect form-control numeric"
                                              :format="selectedScheduleTemplate === 'dollars' ? '$0,0.00' : '0.00'"
                                              data-col="3" :data-row="index"
                                              @onChange="queueScheduleLineUpdate(part, 'body')"></number-formatter>
                          </div>

                          <div class="schedule-table-body-item schedule-body-repair">
                            <number-formatter :key="'repair-' + index + '-' + selectedScheduleTemplate"
                                              :ref="'repair-' + index"
                                              type="text"
                                              v-model="part.priceRepair"
                                              :isCanBeZero="false"
                                              class="noselect form-control numeric"
                                              :format="selectedScheduleTemplate === 'dollars' ? '$0,0.00' : '0.00'"
                                              data-col="4" :data-row="index"
                                              @onChange="queueScheduleLineUpdate(part, 'body')"></number-formatter>
                          </div>

                          <div class="schedule-table-body-item schedule-body-paint">
                            <number-formatter :key="'paint-' + index + '-' + selectedScheduleTemplate"
                                              :ref="'paint-' + index"
                                              type="text"
                                              v-model="part.pricePaint"
                                              class="noselect form-control numeric"
                                              :format="selectedScheduleTemplate === 'dollars' ? '$0,0.00' : '0.00'"
                                              data-col="5" :data-row="index"
                                              :isCanBeZero="false"
                                              @onChange="queueScheduleLineUpdate(part, 'body')"></number-formatter>
                          </div>

                          <div class="schedule-table-body-item schedule-body-trush">
                            <a @click.prevent="removeScheduleLine(part, 'body', index)" class="nav-link btn_trush"
                               style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                          </div>
                        </div>
                      </div>
                    </draggable>

                    <template v-else-if="bodyScheduleLines.length">
                      <div v-for="(part, index) in bodyScheduleLines" :key="part._localId || part.id || index">
                        <div class="schedule-table-body-elem">
                          <div class="schedule-table-body-item schedule-body-line">
                            <input :ref="'line-' + index" v-model="part.name" class="noselect form-control" type="text"
                                   data-col="1" :data-row="index"
                                   @change="queueScheduleLineUpdate(part, 'body')">
                          </div>

                          <div class="schedule-table-body-item schedule-body-code">
                            <input :ref="'code-' + index"
                                   v-model="part.code"
                                   :data-row="index"
                                   class="noselect form-control"
                                   type="text"
                                   data-col="2"
                                   @change="queueScheduleLineUpdate(part, 'body')">
                          </div>

                          <div class="schedule-table-body-item schedule-body-rr">
                            <number-formatter :key="'rr-' + index + '-' + selectedScheduleTemplate"
                                              :ref="'rr-' + index"
                                              type="text"
                                              v-model="part.priceRR"
                                              :value="part.priceRR === 0 ? '' : part.priceRR"
                                              :isCanBeZero="false"
                                              class="noselect form-control numeric"
                                              :format="selectedScheduleTemplate === 'dollars' ? '$0,0.00' : '0.00'"
                                              data-col="3" :data-row="index"
                                              @onChange="queueScheduleLineUpdate(part, 'body')"></number-formatter>
                          </div>

                          <div class="schedule-table-body-item schedule-body-repair">
                            <number-formatter :key="'repair-' + index + '-' + selectedScheduleTemplate"
                                              :ref="'repair-' + index"
                                              type="text"
                                              v-model="part.priceRepair"
                                              :isCanBeZero="false"
                                              class="noselect form-control numeric"
                                              :format="selectedScheduleTemplate === 'dollars' ? '$0,0.00' : '0.00'"
                                              data-col="4" :data-row="index"
                                              @onChange="queueScheduleLineUpdate(part, 'body')"></number-formatter>
                          </div>

                          <div class="schedule-table-body-item schedule-body-paint">
                            <number-formatter :key="'paint-' + index + '-' + selectedScheduleTemplate"
                                              :ref="'paint-' + index"
                                              type="text"
                                              v-model="part.pricePaint"
                                              class="noselect form-control numeric"
                                              :format="selectedScheduleTemplate === 'dollars' ? '$0,0.00' : '0.00'"
                                              data-col="5" :data-row="index"
                                              :isCanBeZero="false"
                                              @onChange="queueScheduleLineUpdate(part, 'body')"></number-formatter>
                          </div>

                          <div class="schedule-table-body-item schedule-body-trush">
                            <a @click.prevent="removeScheduleLine(part, 'body', index)" class="nav-link btn_trush"
                               style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 10px">
              <button @click="addCategoryNameForItem" class="btn tab-header-orders"
                      style="min-width: 105px; margin-left: 25px">
                + Add Category
              </button>
              <button @click="addNewItem" class="btn tab-header-orders" style="min-width: 105px; margin-left: 150px">
                + Add Line
              </button>
            </div>
          </div>
        </div>
        <!-- Add Parts table using backend fields from prices.parts -->
        <div v-if="activeScheduleTab == 'Parts'" class="card">
          <div class="d-flex" style="align-items: flex-start;">
            <!-- Left Sidebar -->
            <div>
              <div class="schedule-table-header">
                <div class="schedule-table-header-item ">
                  Category Name
                </div>
              </div>
              <div class="category-sidebar">
                <div class="category-list-container">
                  <div class="category-search-wrapper">
                    <input
                        v-model="partsCategorySearch"
                        type="text"
                        class="category-search-input"
                        placeholder="Search">
                    <i class="bx bx-search-alt mr-0-5"></i>
                  </div>

                  <ul class="category-list vh-height-65">
                    <li v-for="category in filteredPartsScheduleCategories"
                        :key="category"
                        :class="['category-item', { 'active': activePartsCategory === category }]">
                      <a href="#" @click.prevent="selectCategory(category, 'part')" class="category-link">
                        <span class="category-name">{{ category }}</span>
                        <i class="fa fa-angle-right category-arrow"></i>
                      </a>
                    </li>

                    <li v-if="isAddingPartsCategory" class="category-item">
                      <input
                          ref="newPartsCategoryInput"
                          v-model.trim="newPartsCategoryName"
                          type="text"
                          class="add-category-input"
                          placeholder="Enter category name"
                          @keydown.enter.prevent="saveCategory"
                          @keydown.esc.prevent="cancelAddCategory"
                          @blur="saveCategory">
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Right Table Area -->
            <div class="schedule-table schedule-body-table">
              <div class="schedule-table-header">
                <div class="schedule-table-header-item schedule-header-line" style="padding-left: 15px;">
                  Line Description
                </div>
                <div class="schedule-table-header-item schedule-header-code">
                  Code
                </div>
                <div class="schedule-table-header-item schedule-header-cost">
                  Costs
                </div>
                <div class="schedule-table-header-item schedule-header-trush">
                </div>
              </div>

              <div class="schedule-table-body">
                <div @keydown="handleNavigation">
                  <draggable
                      v-if="partsScheduleLines.length && !normalizedScheduleLineSearch"
                      :list="partsScheduleLinesSource"
                      class="dragArea"
                      tag="div"
                      handle=".schedule-drag-handle"
                      ghost-class="ghost-items"
                      :options="{
                        animation: 150,
                        scroll: true,
                        scrollSensitivity: 150,
                        scrollSpeed: 15,
                        bubbleScroll: true,
                        forceFallback: true,
                        filter: '.numeric, input, .btn_trush, .btn_trush *',
                        preventOnFilter: false
                      }"
                      @start="onBodyLinesDragStart"
                      @end="onScheduleLinesDragEnd('part', partsScheduleLinesSource)"
                  >
                    <div v-for="(part, index) in partsScheduleLinesSource" :key="part._localId || part.id || index">
                      <div class="schedule-table-body-elem">
                        <div class="schedule-table-body-item schedule-drag-handle"
                             style="width: 24px; min-width: 24px; display: flex; align-items: center; justify-content: center;">
                          <i class='bx bx-dots-vertical-rounded'></i>
                        </div>
                        <div class="schedule-table-body-item schedule-body-line">
                          <input
                              :ref="'part-description-' + index"
                              v-model="part.name"
                              class="noselect form-control"
                              type="text"
                              data-col="1"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'part')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-code">
                          <input
                              :ref="'part-code-' + index"
                              v-model="part.code"
                              class="noselect form-control"
                              type="text"
                              data-col="2"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'part')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-cost">
                          <number-formatter
                              :key="'part-cost-' + index + '-' + selectedScheduleTemplate"
                              :ref="'part-cost-' + index"
                              type="text"
                              v-model="part.cost"
                              class="noselect form-control numeric"
                              :format="'$0,0.00'"
                              data-col="3"
                              :data-row="index"
                              @onChange="queueScheduleLineUpdate(part, 'part')"
                          ></number-formatter>
                        </div>

                        <div class="schedule-table-body-item schedule-body-trush">
                          <a @click.prevent="removeScheduleLine(part, 'part', index)" class="nav-link btn_trush"
                             style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                        </div>
                      </div>
                    </div>
                  </draggable>

                  <template v-else-if="partsScheduleLines.length">
                    <div v-for="(part, index) in partsScheduleLines" :key="part._localId || part.id || index">
                      <div class="schedule-table-body-elem">
                        <div class="schedule-table-body-item schedule-body-line">
                          <input
                              :ref="'part-description-' + index"
                              v-model="part.name"
                              class="noselect form-control"
                              type="text"
                              data-col="1"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'part')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-code">
                          <input
                              :ref="'part-code-' + index"
                              v-model="part.code"
                              class="noselect form-control"
                              type="text"
                              data-col="2"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'part')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-cost">
                          <number-formatter
                              :key="'part-cost-' + index + '-' + selectedScheduleTemplate"
                              :ref="'part-cost-' + index"
                              type="text"
                              v-model="part.cost"
                              class="noselect form-control numeric"
                              :format="'$0,0.00'"
                              data-col="3"
                              :data-row="index"
                              @onChange="queueScheduleLineUpdate(part, 'part')"
                          ></number-formatter>
                        </div>

                        <div class="schedule-table-body-item schedule-body-trush">
                          <a @click.prevent="removeScheduleLine(part, 'part', index)" class="nav-link btn_trush"
                             style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px">
            <button @click="addCategoryNameForItem" class="btn tab-header-orders"
                    style="min-width: 105px; margin-left: 25px">
              + Add Category
            </button>
            <button @click="addNewItem" class="btn tab-header-orders" style="min-width: 105px; margin-left: 150px">
              + Add Line
            </button>
          </div>
        </div>

        <div v-if="activeScheduleTab == 'Sublet'">
          <div class="d-flex" style="align-items: flex-start;">
            <!-- Left Sidebar -->
            <div>
              <div class="schedule-table-header">
                <div class="schedule-table-header-item ">
                  Category Name
                </div>
              </div>
              <div class="category-sidebar">
                <div class="category-list-container">
                  <div class="category-search-wrapper">
                    <input
                        v-model="subletCategorySearch"
                        type="text"
                        class="category-search-input"
                        placeholder="Search">
                    <i class="bx bx-search-alt mr-0-5"></i>
                  </div>

                  <ul class="category-list vh-height-65">
                    <li v-for="category in filteredSubletScheduleCategories"
                        :key="category"
                        :class="['category-item', { 'active': activeSubletCategory === category }]">
                      <a href="#" @click.prevent="selectCategory(category, 'sublet')" class="category-link">
                        <span class="category-name">{{ category }}</span>
                        <i class="fa fa-angle-right category-arrow"></i>
                      </a>
                    </li>

                    <li v-if="isAddingSubletCategory" class="category-item">
                      <input
                          ref="newSubletCategoryInput"
                          v-model.trim="newSubletCategoryName"
                          type="text"
                          class="add-category-input"
                          placeholder="Enter category name"
                          @keydown.enter.prevent="saveCategory"
                          @keydown.esc.prevent="cancelAddCategory"
                          @blur="saveCategory">
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Right Table Area -->
            <div class="schedule-table schedule-body-table">
              <div class="schedule-table-header">
                <div class="schedule-table-header-item schedule-header-line" style="padding-left: 15px;">
                  Line Description
                </div>
                <div class="schedule-table-header-item schedule-header-supplier">
                  Supplier
                </div>
                <div class="schedule-table-header-item schedule-header-code">
                  Code
                </div>
                <div class="schedule-table-header-item schedule-header-cost">
                  Costs
                </div>
                <div class="schedule-table-header-item schedule-header-trush">
                </div>
              </div>

              <div class="schedule-table-body">
                <div @keydown="handleNavigation">
                  <draggable
                      v-if="subletScheduleLines.length && !normalizedScheduleLineSearch"
                      :list="subletScheduleLinesSource"
                      class="dragArea"
                      tag="div"
                      handle=".schedule-drag-handle"
                      ghost-class="ghost-items"
                      :options="{
                        animation: 150,
                        scroll: true,
                        scrollSensitivity: 150,
                        scrollSpeed: 15,
                        bubbleScroll: true,
                        forceFallback: true,
                        filter: '.numeric, input, .btn_trush, .btn_trush *',
                        preventOnFilter: false
                      }"
                      @start="onBodyLinesDragStart"
                      @end="onScheduleLinesDragEnd('sublet', subletScheduleLinesSource)"
                  >
                    <div v-for="(part, index) in subletScheduleLinesSource" :key="part._localId ||part.id || index">
                      <div class="schedule-table-body-elem">
                        <div class="schedule-table-body-item schedule-drag-handle"
                             style="width: 24px; min-width: 24px; display: flex; align-items: center; justify-content: center;">
                          <i class='bx bx-dots-vertical-rounded'></i>
                        </div>
                        <div class="schedule-table-body-item schedule-body-line">
                          <input
                              :ref="'description-' + index"
                              v-model="part.name"
                              class="noselect form-control"
                              type="text"
                              data-col="1"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'sublet')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-supplier">
                          <input
                              :ref="'supplier-' + index"
                              v-model="part.supplier"
                              class="noselect form-control"
                              type="text"
                              data-col="2"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'sublet')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-code">
                          <input
                              :ref="'code-' + index"
                              v-model="part.code"
                              class="noselect form-control"
                              type="text"
                              data-col="3"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'sublet')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-cost">
                          <number-formatter
                              :key="'cost-' + index + '-' + selectedScheduleTemplate"
                              :ref="'cost-' + index"
                              type="text"
                              v-model="part.cost"
                              class="noselect form-control numeric"
                              :format="'$0,0.00'"
                              data-col="4"
                              :data-row="index"
                              @onChange="queueScheduleLineUpdate(part, 'sublet')"
                          ></number-formatter>
                        </div>

                        <div class="schedule-table-body-item schedule-body-trush">
                          <a @click.prevent="removeScheduleLine(part, 'sublet', index)" class="nav-link btn_trush"
                             style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                        </div>
                      </div>
                    </div>
                  </draggable>

                  <template v-else-if="subletScheduleLines.length">
                    <div v-for="(part, index) in subletScheduleLines" :key="part._localId ||part.id || index">
                      <div class="schedule-table-body-elem">
                        <div class="schedule-table-body-item schedule-body-line">
                          <input
                              :ref="'description-' + index"
                              v-model="part.name"
                              class="noselect form-control"
                              type="text"
                              data-col="1"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'sublet')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-supplier">
                          <input
                              :ref="'supplier-' + index"
                              v-model="part.supplier"
                              class="noselect form-control"
                              type="text"
                              data-col="2"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'sublet')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-code">
                          <input
                              :ref="'code-' + index"
                              v-model="part.code"
                              class="noselect form-control"
                              type="text"
                              data-col="3"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'sublet')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-cost">
                          <number-formatter
                              :key="'cost-' + index + '-' + selectedScheduleTemplate"
                              :ref="'cost-' + index"
                              type="text"
                              v-model="part.cost"
                              class="noselect form-control numeric"
                              :format="'$0,0.00'"
                              data-col="4"
                              :data-row="index"
                              @onChange="queueScheduleLineUpdate(part, 'sublet')"
                          ></number-formatter>
                        </div>

                        <div class="schedule-table-body-item schedule-body-trush">
                          <a @click.prevent="removeScheduleLine(part, 'sublet', index)" class="nav-link btn_trush"
                             style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px">
            <button @click="addCategoryNameForItem" class="btn tab-header-orders"
                    style="min-width: 105px; margin-left: 25px">
              + Add Category
            </button>
            <button @click="addNewItem" class="btn tab-header-orders" style="min-width: 105px; margin-left: 150px">
              + Add Line
            </button>
          </div>
        </div>

        <!-- EstimateSchedules.vue: around Miscellaneous tab block -->
        <!-- Add Miscellaneous table using backend fields from prices.misc -->
        <div v-if="activeScheduleTab == 'Miscellaneous'" class="card">
          <div class="d-flex" style="align-items: flex-start;">
            <!-- Left Sidebar -->
            <div>
              <div class="schedule-table-header">
                <div class="schedule-table-header-item ">
                  Category Name
                </div>
              </div>
              <div class="category-sidebar">
                <div class="category-list-container">
                  <div class="category-search-wrapper">
                    <input
                        v-model="miscCategorySearch"
                        type="text"
                        class="category-search-input"
                        placeholder="Search">
                    <i class="bx bx-search-alt mr-0-5"></i>
                  </div>

                  <ul class="category-list vh-height-65">
                    <li v-for="category in filteredMiscScheduleCategories"
                        :key="category"
                        :class="['category-item', { 'active': activeMiscCategory === category }]">
                      <a href="#" @click.prevent="selectCategory(category, 'misc')" class="category-link">
                        <span class="category-name">{{ category }}</span>
                        <i class="fa fa-angle-right category-arrow"></i>
                      </a>
                    </li>

                    <li v-if="isAddingMiscCategory" class="category-item">
                      <input
                          ref="newMiscCategoryInput"
                          v-model.trim="newMiscCategoryName"
                          type="text"
                          class="add-category-input"
                          placeholder="Enter category name"
                          @keydown.enter.prevent="saveCategory"
                          @keydown.esc.prevent="cancelAddCategory"
                          @blur="saveCategory">
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Right Table Area -->
            <div class="schedule-table schedule-body-table">
              <div class="schedule-table-header">
                <div class="schedule-table-header-item schedule-header-line" style="padding-left: 15px;">
                  Line Description
                </div>
                <div class="schedule-table-header-item schedule-header-supplier">
                  Supplier
                </div>
                <div class="schedule-table-header-item schedule-header-code">
                  Code
                </div>
                <div class="schedule-table-header-item schedule-header-cost">
                  Costs
                </div>
                <div class="schedule-table-header-item schedule-header-trush">
                </div>
              </div>

              <div class="schedule-table-body">
                <div @keydown="handleNavigation">
                  <draggable
                      v-if="miscScheduleLines.length && !normalizedScheduleLineSearch"
                      :list="miscScheduleLinesSource"
                      class="dragArea"
                      tag="div"
                      handle=".schedule-drag-handle"
                      ghost-class="ghost-items"
                      :options="{
                        animation: 150,
                        scroll: true,
                        scrollSensitivity: 150,
                        scrollSpeed: 15,
                        bubbleScroll: true,
                        forceFallback: true,
                        filter: '.numeric, input, .btn_trush, .btn_trush *',
                        preventOnFilter: false
                      }"
                      @start="onBodyLinesDragStart"
                      @end="onScheduleLinesDragEnd('misc', miscScheduleLinesSource)"
                  >
                    <div v-for="(part, index) in miscScheduleLinesSource" :key="part._localId ||part.id || index">
                      <div class="schedule-table-body-elem">
                        <div class="schedule-table-body-item schedule-drag-handle"
                             style="width: 24px; min-width: 24px; display: flex; align-items: center; justify-content: center;">
                          <i class='bx bx-dots-vertical-rounded'></i>
                        </div>
                        <div class="schedule-table-body-item schedule-body-line">
                          <input
                              :ref="'misc-description-' + index"
                              v-model="part.name"
                              class="noselect form-control"
                              type="text"
                              data-col="1"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'misc')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-supplier">
                          <input
                              :ref="'misc-supplier-' + index"
                              v-model="part.supplier"
                              class="noselect form-control"
                              type="text"
                              data-col="2"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'misc')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-code">
                          <input
                              :ref="'misc-code-' + index"
                              v-model="part.code"
                              class="noselect form-control"
                              type="text"
                              data-col="3"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'misc')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-cost">
                          <number-formatter
                              :key="'misc-cost-' + index + '-' + selectedScheduleTemplate"
                              :ref="'misc-cost-' + index"
                              type="text"
                              v-model="part.cost"
                              class="noselect form-control numeric"
                              :format="'$0,0.00'"
                              data-col="4"
                              :data-row="index"
                              @onChange="queueScheduleLineUpdate(part, 'misc')"
                          ></number-formatter>
                        </div>

                        <div class="schedule-table-body-item schedule-body-trush">
                          <a @click.prevent="removeScheduleLine(part, 'misc', index)" class="nav-link btn_trush"
                             style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                        </div>
                      </div>
                    </div>
                  </draggable>

                  <template v-else-if="miscScheduleLines.length">
                    <div v-for="(part, index) in miscScheduleLines" :key="part._localId ||part.id || index">
                      <div class="schedule-table-body-elem">
                        <div class="schedule-table-body-item schedule-body-line">
                          <input
                              :ref="'misc-description-' + index"
                              v-model="part.name"
                              class="noselect form-control"
                              type="text"
                              data-col="1"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'misc')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-supplier">
                          <input
                              :ref="'misc-supplier-' + index"
                              v-model="part.supplier"
                              class="noselect form-control"
                              type="text"
                              data-col="2"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'misc')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-code">
                          <input
                              :ref="'misc-code-' + index"
                              v-model="part.code"
                              class="noselect form-control"
                              type="text"
                              data-col="3"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'misc')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-cost">
                          <number-formatter
                              :key="'misc-cost-' + index + '-' + selectedScheduleTemplate"
                              :ref="'misc-cost-' + index"
                              type="text"
                              v-model="part.cost"
                              class="noselect form-control numeric"
                              :format="'$0,0.00'"
                              data-col="4"
                              :data-row="index"
                              @onChange="queueScheduleLineUpdate(part, 'misc')"
                          ></number-formatter>
                        </div>

                        <div class="schedule-table-body-item schedule-body-trush">
                          <a @click.prevent="removeScheduleLine(part, 'misc', index)" class="nav-link btn_trush"
                             style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px">
            <button @click="addCategoryNameForItem" class="btn tab-header-orders"
                    style="min-width: 105px; margin-left: 25px">
              + Add Category
            </button>
            <button @click="addNewItem" class="btn tab-header-orders" style="min-width: 105px; margin-left: 150px">
              + Add Line
            </button>
          </div>
        </div>

        <!-- Add Mechanical table using backend fields from prices.mechanicals -->
        <div v-if="activeScheduleTab == 'Mechanical'" class="card">
          <div class="d-flex" style="align-items: flex-start;">
            <!-- Left Sidebar -->
            <div>
              <div class="schedule-table-header">
                <div class="schedule-table-header-item ">
                  Category Name
                </div>
              </div>
              <div class="category-sidebar">
                <div class="category-list-container">
                  <div class="category-search-wrapper">
                    <input
                        v-model="mechanicalCategorySearch"
                        type="text"
                        class="category-search-input"
                        placeholder="Search">
                    <i class="bx bx-search-alt mr-0-5"></i>
                  </div>

                  <ul class="category-list vh-height-65">
                    <li v-for="category in filteredMechanicalScheduleCategories"
                        :key="category"
                        :class="['category-item', { 'active': activeMechanicalCategory === category }]">
                      <a href="#" @click.prevent="selectCategory(category, 'mechanical')" class="category-link">
                        <span class="category-name">{{ category }}</span>
                        <i class="fa fa-angle-right category-arrow"></i>
                      </a>
                    </li>

                    <li v-if="isAddingMechanicalCategory" class="category-item">
                      <input
                          ref="newMechanicalCategoryInput"
                          v-model.trim="newMechanicalCategoryName"
                          type="text"
                          class="add-category-input"
                          placeholder="Enter category name"
                          @keydown.enter.prevent="saveCategory"
                          @keydown.esc.prevent="cancelAddCategory"
                          @blur="saveCategory">
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Right Table Area -->
            <div class="schedule-table schedule-body-table">
              <div class="schedule-table-header">
                <div class="schedule-table-header-item schedule-header-line" style="padding-left: 15px;">
                  Line Description
                </div>
                <div class="schedule-table-header-item schedule-header-supplier">
                  Supplier
                </div>
                <div class="schedule-table-header-item schedule-header-code">
                  Code
                </div>
                <div class="schedule-table-header-item schedule-header-cost">
                  Costs
                </div>
                <div class="schedule-table-header-item schedule-header-trush">
                </div>
              </div>

              <div class="schedule-table-body">
                <div @keydown="handleNavigation">
                  <draggable
                      v-if="mechanicalScheduleLines.length && !normalizedScheduleLineSearch"
                      :list="mechanicalScheduleLinesSource"
                      class="dragArea"
                      tag="div"
                      handle=".schedule-drag-handle"
                      ghost-class="ghost-items"
                      :options="{
                        animation: 150,
                        scroll: true,
                        scrollSensitivity: 150,
                        scrollSpeed: 15,
                        bubbleScroll: true,
                        forceFallback: true,
                        filter: '.numeric, input, .btn_trush, .btn_trush *',
                        preventOnFilter: false
                      }"
                      @start="onBodyLinesDragStart"
                      @end="onScheduleLinesDragEnd('mechanical', mechanicalScheduleLinesSource)"
                  >
                    <div v-for="(part, index) in mechanicalScheduleLinesSource" :key="part._localId ||part.id || index">
                      <div class="schedule-table-body-elem">
                        <div class="schedule-table-body-item schedule-drag-handle"
                             style="width: 24px; min-width: 24px; display: flex; align-items: center; justify-content: center;">
                          <i class='bx bx-dots-vertical-rounded'></i>
                        </div>
                        <div class="schedule-table-body-item schedule-body-line">
                          <input
                              :ref="'mechanical-description-' + index"
                              v-model="part.name"
                              class="noselect form-control"
                              type="text"
                              data-col="1"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'mechanical')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-supplier">
                          <input
                              :ref="'mechanical-supplier-' + index"
                              v-model="part.supplier"
                              class="noselect form-control"
                              type="text"
                              data-col="2"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'mechanical')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-code">
                          <input
                              :ref="'mechanical-code-' + index"
                              v-model="part.code"
                              class="noselect form-control"
                              type="text"
                              data-col="3"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'mechanical')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-cost">
                          <number-formatter
                              :key="'mechanical-cost-' + index + '-' + selectedScheduleTemplate"
                              :ref="'mechanical-cost-' + index"
                              type="text"
                              v-model="part.cost"
                              class="noselect form-control numeric"
                              :format="'$0,0.00'"
                              data-col="4"
                              :data-row="index"
                              @onChange="queueScheduleLineUpdate(part, 'mechanical')"
                          ></number-formatter>
                        </div>
                        <div class="schedule-table-body-item schedule-body-trush">
                          <a @click.prevent="removeScheduleLine(part, 'mechanical', index)" class="nav-link btn_trush"
                             style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                        </div>
                      </div>
                    </div>
                  </draggable>

                  <template v-else-if="mechanicalScheduleLines.length">
                    <div v-for="(part, index) in mechanicalScheduleLines" :key="part._localId ||part.id || index">
                      <div class="schedule-table-body-elem">
                        <div class="schedule-table-body-item schedule-body-line">
                          <input
                              :ref="'mechanical-description-' + index"
                              v-model="part.name"
                              class="noselect form-control"
                              type="text"
                              data-col="1"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'mechanical')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-supplier">
                          <input
                              :ref="'mechanical-supplier-' + index"
                              v-model="part.supplier"
                              class="noselect form-control"
                              type="text"
                              data-col="2"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'mechanical')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-code">
                          <input
                              :ref="'mechanical-code-' + index"
                              v-model="part.code"
                              class="noselect form-control"
                              type="text"
                              data-col="3"
                              :data-row="index"
                              @change="queueScheduleLineUpdate(part, 'mechanical')"
                          >
                        </div>

                        <div class="schedule-table-body-item schedule-body-cost">
                          <number-formatter
                              :key="'mechanical-cost-' + index + '-' + selectedScheduleTemplate"
                              :ref="'mechanical-cost-' + index"
                              type="text"
                              v-model="part.cost"
                              class="noselect form-control numeric"
                              :format="'$0,0.00'"
                              data-col="4"
                              :data-row="index"
                              @onChange="queueScheduleLineUpdate(part, 'mechanical')"
                          ></number-formatter>
                        </div>
                        <div class="schedule-table-body-item schedule-body-trush">
                          <a @click.prevent="removeScheduleLine(part, 'mechanical', index)" class="nav-link btn_trush"
                             style="width: 20px; height: 20px; margin-top: 5px; cursor: pointer;"></a>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px">
            <button @click="addCategoryNameForItem" class="btn tab-header-orders"
                    style="min-width: 105px; margin-left: 25px">
              + Add Category
            </button>
            <button @click="addNewItem" class="btn tab-header-orders" style="min-width: 105px; margin-left: 150px">
              + Add Line
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import NumberFormatter from '@/components/utility/number-formatter'
import draggable from 'vuedraggable'
import SearchFilter2 from '@/components/search-filter/search-filter-2.vue'
import vue2Dropzone from 'vue2-dropzone'
import { appConfig } from '@/config'
import Axios from 'axios'
import NProgress from 'nprogress'
import { uuid } from 'vue-uuid'

export default {
  name: 'EstimateSchedules',
  components: {
    SearchFilter2,
    draggable,
    Multiselect,
    NumberFormatter,
    vueDropzone: vue2Dropzone,
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      newBodyCategoryName: '',
      isAddingBodyCategory: false,
      isSavingBodyCategory: false,
      bodyCategorySearch: '',
      selectedSchedule: null,
      activeBodyCategory: null,
      newPartsCategoryName: '',
      isAddingPartsCategory: false,
      partsCategorySearch: '',
      activePartsCategory: null,

      newSubletCategoryName: '',
      isAddingSubletCategory: false,
      subletCategorySearch: '',
      activeSubletCategory: null,

      newMiscCategoryName: '',
      isAddingMiscCategory: false,
      miscCategorySearch: '',
      activeMiscCategory: null,

      newMechanicalCategoryName: '',
      isAddingMechanicalCategory: false,
      mechanicalCategorySearch: '',
      activeMechanicalCategory: null,

      showCsvDropzone: false,
      scheduleTabs: ['Body Section', 'Parts', 'Sublet', 'Miscellaneous', 'Mechanical'],
      activeScheduleTab: 'Body Section',
      scheduleTemplateOptions: ['dollars', 'hours'],
      selectedScheduleTemplate: 'dollars',
      scheduleLineSearch: '',
      file_ids: [],
      filesAfterUpload: [],
      schedules: [],
      isBodyDragging: false,
      fileUploadDropzoneOptions: {
        headers: { 'Authorization': localStorage.getItem('token') },
        method: 'post',
        maxFilesize: 500,
        timeout: 300000,
        clickable: '.browse-btn-files',
        thumbnailWidth: 200,
        addRemoveLinks: false,
        acceptedFiles: '.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        dictFileTooBig: 'Your doc has exceeded the maximum limit of 50MB per doc. Please reduce the file size and upload again',
      },
      updateScheduleLineTimers: {},
    }
  },
  computed: {

    //  filtered categories for the left sidebar search
    normalizedScheduleLineSearch () {
      return String(this.scheduleLineSearch || '').toLowerCase().trim()
    },
    filteredSchedules () {
      const query = this.normalizedScheduleLineSearch

      if (!query) {
        return this.schedules
      }

      return this.schedules.filter(schedule => {
        const name = schedule && schedule.name !== undefined && schedule.name !== null
          ? String(schedule.name).toLowerCase()
          : ''
        const type = schedule && schedule.id < 0 ? 'managed - rs' : 'self - managed'

        return name.includes(query) || type.includes(query)
      })
    },
    filteredBodyScheduleCategories () {
      const categories = this.bodyScheduleCategories

      if (!this.bodyCategorySearch) {
        return categories
      }

      const query = this.bodyCategorySearch.toLowerCase().trim()

      return categories.filter(category =>
          String(category).toLowerCase().includes(query)
      )
    },
    csvDropzoneUrl () {
      if (!this.selectedSchedule || !this.selectedSchedule.id) {
        return `${appConfig.baseAPIURL || ''}/fe/settings/schedule/import-xls`
      }

      let importType = ''

      switch (this.activeScheduleTab) {
        case 'Body Section':
          importType = 'importBody'
          break
        case 'Parts':
        case 'Part':
          importType = 'importParts'
          break
        case 'Sublet':
          importType = 'importSublet'
          break
        case 'Miscellaneous':
          importType = 'importMisc'
          break
        case 'Mechanical':
          importType = 'importMechanical'
          break
      }

      return `${appConfig.baseAPIURL || ''}/fe/settings/schedule/${this.selectedSchedule.id}/import-xls`
    },
    dropzoneOptions () {
      return {
        ...this.fileUploadDropzoneOptions,
        url: this.csvDropzoneUrl,
      }
    },
    bodyScheduleCategories () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices || !this.selectedSchedule.prices.bodies) {
        return []
      }

      return Object.keys(this.selectedSchedule.prices.bodies)
    },
    // Add before line ~996: source array for draggable in Body Section
    bodyScheduleLinesSource () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices || !this.selectedSchedule.prices.bodies || !this.activeBodyCategory) {
        return []
      }

      return this.selectedSchedule.prices.bodies[this.activeBodyCategory] || []
    },
    // filtered list for rendering, source stays mutable for draggable
    bodyScheduleLines () {
      return this.bodyScheduleLinesSource.filter(line => this.matchesScheduleLineSearch(line, [
        'name',
        'code',
        'priceRR',
        'priceRepair',
        'pricePaint'
      ]))
    },

    partsScheduleCategories () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices || !this.selectedSchedule.prices.parts || Array.isArray(this.selectedSchedule.prices.parts)) return []
      return Object.keys(this.selectedSchedule.prices.parts)
    },
    filteredPartsScheduleCategories () {
      if (!this.partsCategorySearch) return this.partsScheduleCategories
      return this.partsScheduleCategories.filter(c => String(c).toLowerCase().includes(this.partsCategorySearch.toLowerCase().trim()))
    },
    partsScheduleLinesSource () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices || !this.selectedSchedule.prices.parts || !this.activePartsCategory || Array.isArray(this.selectedSchedule.prices.parts)) {
        return []
      }

      return this.selectedSchedule.prices.parts[this.activePartsCategory] || []
    },
    partsScheduleLines () {
      return this.partsScheduleLinesSource.filter(line => this.matchesScheduleLineSearch(line, [
        'name',
        'code',
        'cost'
      ]))
    },
    subletScheduleCategories () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices || !this.selectedSchedule.prices.sublets || Array.isArray(this.selectedSchedule.prices.sublets)) return []
      return Object.keys(this.selectedSchedule.prices.sublets)
    },
    filteredSubletScheduleCategories () {
      if (!this.subletCategorySearch) return this.subletScheduleCategories
      return this.subletScheduleCategories.filter(c => String(c).toLowerCase().includes(this.subletCategorySearch.toLowerCase().trim()))
    },
    subletScheduleLinesSource () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices || !this.selectedSchedule.prices.sublets || !this.activeSubletCategory || Array.isArray(this.selectedSchedule.prices.sublets)) {
        return []
      }

      return this.selectedSchedule.prices.sublets[this.activeSubletCategory] || []
    },
    subletScheduleLines () {
      return this.subletScheduleLinesSource.filter(line => this.matchesScheduleLineSearch(line, [
        'name',
        'supplier',
        'code',
        'cost'
      ]))
    },
    miscScheduleCategories () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices || !this.selectedSchedule.prices.miscs || Array.isArray(this.selectedSchedule.prices.miscs)) return []
      return Object.keys(this.selectedSchedule.prices.miscs)
    },
    filteredMiscScheduleCategories () {
      if (!this.miscCategorySearch) return this.miscScheduleCategories
      return this.miscScheduleCategories.filter(c => String(c).toLowerCase().includes(this.miscCategorySearch.toLowerCase().trim()))
    },
    miscScheduleLinesSource () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices || !this.selectedSchedule.prices.miscs || !this.activeMiscCategory || Array.isArray(this.selectedSchedule.prices.miscs)) {
        return []
      }

      return this.selectedSchedule.prices.miscs[this.activeMiscCategory] || []
    },
    miscScheduleLines () {
      return this.miscScheduleLinesSource.filter(line => this.matchesScheduleLineSearch(line, [
        'name',
        'supplier',
        'code',
        'cost'
      ]))
    },
    mechanicalScheduleCategories () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices || !this.selectedSchedule.prices.mechanicals) return []
      if (Array.isArray(this.selectedSchedule.prices.mechanicals)) return []
      return Object.keys(this.selectedSchedule.prices.mechanicals)
    },
    filteredMechanicalScheduleCategories () {
      if (!this.mechanicalCategorySearch) return this.mechanicalScheduleCategories
      return this.mechanicalScheduleCategories.filter(c => String(c).toLowerCase().includes(this.mechanicalCategorySearch.toLowerCase().trim()))
    },
    mechanicalScheduleLinesSource () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices || !this.selectedSchedule.prices.mechanicals || !this.activeMechanicalCategory) {
        return []
      }
      if (Array.isArray(this.selectedSchedule.prices.mechanicals)) return []

      return this.selectedSchedule.prices.mechanicals[this.activeMechanicalCategory] || []
    },
    mechanicalScheduleLines () {
      return this.mechanicalScheduleLinesSource.filter(line => this.matchesScheduleLineSearch(line, [
        'name',
        'supplier',
        'code',
        'cost',
        'price',
        'hours'
      ]))
    },
  },
  methods: {
    matchesScheduleLineSearch (line, fields = []) {
      const query = this.normalizedScheduleLineSearch

      if (!query) {
        return true
      }

      return fields.some(field => {
        const value = line && line[field] !== undefined && line[field] !== null
          ? String(line[field]).toLowerCase()
          : ''

        return value.includes(query)
      })
    },
    getScheduleLinesSource (type) {
      if (!this.selectedSchedule || !this.selectedSchedule.prices) {
        return []
      }

      if (type === 'body') {
        return this.selectedSchedule.prices.bodies?.[this.activeBodyCategory] || []
      }
      if (type === 'part') {
        return this.selectedSchedule.prices.parts?.[this.activePartsCategory] || []
      }
      if (type === 'sublet') {
        return this.selectedSchedule.prices.sublets?.[this.activeSubletCategory] || []
      }
      if (type === 'misc') {
        return this.selectedSchedule.prices.miscs?.[this.activeMiscCategory] || []
      }
      if (type === 'mechanical') {
        return this.selectedSchedule.prices.mechanicals?.[this.activeMechanicalCategory] || []
      }

      return []
    },
    // Add after line ~1141: persist order after dragging body lines
    onBodyLinesDragStart () {
      this.isBodyDragging = true

      if (window.getSelection) {
        const selection = window.getSelection()

        if (selection && selection.removeAllRanges) {
          selection.removeAllRanges()
        }
      }
    },
    //send sorted body items to backend after drag
    onBodyLinesDragEnd () {
      this.onScheduleLinesDragEnd('body', this.bodyScheduleLinesSource)
    },
    onScheduleLinesDragEnd (type, lines) {
      this.isBodyDragging = false

      if (window.getSelection) {
        const selection = window.getSelection()

        if (selection && selection.removeAllRanges) {
          selection.removeAllRanges()
        }
      }

      if (!this.selectedSchedule || !this.selectedSchedule.id || !Array.isArray(lines) || !lines.length) {
        return
      }

      const sort = lines
          .filter(line => line && line.id)
          .map((line, index) => ({
            id: line.id,
            index,
          }))

      if (!sort.length) {
        return
      }

      this.sendScheduleSort(type, sort)
    },
    // send sort order to backend
    sendScheduleSort (type, sort) {
      if (!this.selectedSchedule || !this.selectedSchedule.id || !Array.isArray(sort) || !sort.length) {
        return Promise.resolve()
      }

      return Axios.post(`/fe/settings/schedule/${this.selectedSchedule.id}/sort`, {
        type,
        sort,
      })
          .catch(error => {
            console.error('Error saving schedule sort:', error)
          })
    },
    removeScheduleLineLocally (part, type) {
      const lines = this.getScheduleLinesSource(type)
      const removeIndex = lines.findIndex(line =>
        (part.id && line.id === part.id) ||
        (part._localId && line._localId === part._localId)
      )

      if (removeIndex !== -1) {
        lines.splice(removeIndex, 1)
      }
    },
    removeScheduleLine (part, type, index) {
      if (!part || !part.id) {
        this.removeScheduleLineLocally(part, type)
        return
      }
      NProgress.start()

      Axios.delete(`/fe/settings/schedule/${this.selectedSchedule.id}/line/${part.id}`, { data: { type: type } })
          .then(response => {
            if (response && response.data && response.data._status) {
              this.removeScheduleLineLocally(part, type)
            }
          })
          .catch(error => {
            console.error('Error deleted schedule line:', error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    addNewItem () {
      if (!this.selectedSchedule || !this.selectedSchedule.prices) return

      let section, activeCategory
      if (this.activeScheduleTab === 'Body Section') {
        section = 'bodies'
        activeCategory = this.activeBodyCategory
      } else if (this.activeScheduleTab === 'Parts' || this.activeScheduleTab === 'Part') {
        section = 'parts'
        activeCategory = this.activePartsCategory
      } else if (this.activeScheduleTab === 'Sublet') {
        section = 'sublets'
        activeCategory = this.activeSubletCategory
      } else if (this.activeScheduleTab === 'Miscellaneous') {
        section = 'miscs'
        activeCategory = this.activeMiscCategory
      } else if (this.activeScheduleTab === 'Mechanical') {
        section = 'mechanicals'
        activeCategory = this.activeMechanicalCategory
      }

      if (!section || !activeCategory) return

      if (!Array.isArray(this.selectedSchedule.prices[section][activeCategory])) {
        this.$set(this.selectedSchedule.prices[section], activeCategory, [])
      }

      const newLine = {
        id: null,
        _localId: uuid.v1(),
        name: '',
        code: '',
        priceRR: '',
        priceRepair: '',
        pricePaint: '',
        cost: '',
        supplier: '',
        isNew: true,
      }

      this.selectedSchedule.prices[section][activeCategory].push(newLine)

      this.$nextTick(() => {
        const index = this.selectedSchedule.prices[section][activeCategory].length - 1
        this.focusElement(index, 1)
      })
    },
    insertNewItemAfter (rowIndex) {
      if (!this.selectedSchedule || !this.selectedSchedule.prices) return

      let section, activeCategory, firstCol

      if (this.activeScheduleTab === 'Body Section') {
        section = 'bodies'
        activeCategory = this.activeBodyCategory
        firstCol = 1
      } else if (this.activeScheduleTab === 'Parts' || this.activeScheduleTab === 'Part') {
        section = 'parts'
        activeCategory = this.activePartsCategory
        firstCol = 1
      } else if (this.activeScheduleTab === 'Sublet') {
        section = 'sublets'
        activeCategory = this.activeSubletCategory
        firstCol = 1
      } else if (this.activeScheduleTab === 'Miscellaneous') {
        section = 'miscs'
        activeCategory = this.activeMiscCategory
        firstCol = 1
      } else if (this.activeScheduleTab === 'Mechanical') {
        section = 'mechanicals'
        activeCategory = this.activeMechanicalCategory
        firstCol = 1
      }

      if (!section || !activeCategory) return

      if (!Array.isArray(this.selectedSchedule.prices[section][activeCategory])) {
        this.$set(this.selectedSchedule.prices[section], activeCategory, [])
      }

      const lines = this.selectedSchedule.prices[section][activeCategory]

      const newLine = {
        id: null,
        _localId: uuid.v1(),
        name: '',
        code: '',
        priceRR: '',
        priceRepair: '',
        pricePaint: '',
        cost: '',
        supplier: '',
        isNew: true,
      }

      lines.splice(rowIndex + 1, 0, newLine)

      this.$nextTick(() => {
        this.focusElement(rowIndex + 1, firstCol)
      })
    },
    addCategoryNameForItem () {
      if (!this.selectedSchedule || !this.selectedSchedule.id) return

      let inputRefName
      if (this.activeScheduleTab === 'Body Section') {
        if (this.isAddingBodyCategory && this.newBodyCategoryName.trim()) this.saveCategory()
        this.isAddingBodyCategory = true
        this.newBodyCategoryName = ''
        inputRefName = 'newBodyCategoryInput'
      } else if (this.activeScheduleTab === 'Parts' || this.activeScheduleTab === 'Part') {
        if (this.isAddingPartsCategory && this.newPartsCategoryName.trim()) this.saveCategory()
        this.isAddingPartsCategory = true
        this.newPartsCategoryName = ''
        inputRefName = 'newPartsCategoryInput'
      } else if (this.activeScheduleTab === 'Sublet') {
        if (this.isAddingSubletCategory && this.newSubletCategoryName.trim()) this.saveCategory()
        this.isAddingSubletCategory = true
        this.newSubletCategoryName = ''
        inputRefName = 'newSubletCategoryInput'
      } else if (this.activeScheduleTab === 'Miscellaneous') {
        if (this.isAddingMiscCategory && this.newMiscCategoryName.trim()) this.saveCategory()
        this.isAddingMiscCategory = true
        this.newMiscCategoryName = ''
        inputRefName = 'newMiscCategoryInput'
      } else if (this.activeScheduleTab === 'Mechanical') {
        if (this.isAddingMechanicalCategory && this.newMechanicalCategoryName.trim()) this.saveCategory()
        this.isAddingMechanicalCategory = true
        this.newMechanicalCategoryName = ''
        inputRefName = 'newMechanicalCategoryInput'
      }

      this.$nextTick(() => {
        const input = this.$refs[inputRefName]
        if (input && input.focus) {
          input.focus()
        }
      })
    },

    cancelAddCategory () {
      if (this.activeScheduleTab === 'Body Section') {
        this.isAddingBodyCategory = false
        this.newBodyCategoryName = ''
      } else if (this.activeScheduleTab === 'Parts' ||this.activeScheduleTab === 'Part' ) {
        this.isAddingPartsCategory = false
        this.newPartsCategoryName = ''
      } else if (this.activeScheduleTab === 'Sublet') {
        this.isAddingSubletCategory = false
        this.newSubletCategoryName = ''
      } else if (this.activeScheduleTab === 'Miscellaneous') {
        this.isAddingMiscCategory = false
        this.newMiscCategoryName = ''
      } else if (this.activeScheduleTab === 'Mechanical') {
        this.isAddingMechanicalCategory = false
        this.newMechanicalCategoryName = ''
      }
    },

    saveCategory () {
      if (!this.selectedSchedule || !this.selectedSchedule.id) return

      let categoryName = ''
      let section = ''

      if (this.activeScheduleTab === 'Body Section') {
        categoryName = (this.newBodyCategoryName || '').trim()
        section = 'bodies'
      } else if (this.activeScheduleTab === 'Parts' ||this.activeScheduleTab === 'Part') {
        categoryName = (this.newPartsCategoryName || '').trim()
        section = 'parts'
      } else if (this.activeScheduleTab === 'Sublet') {
        categoryName = (this.newSubletCategoryName || '').trim()
        section = 'sublets'
      } else if (this.activeScheduleTab === 'Miscellaneous') {
        categoryName = (this.newMiscCategoryName || '').trim()
        section = 'miscs'
      } else if (this.activeScheduleTab === 'Mechanical') {
        categoryName = (this.newMechanicalCategoryName || '').trim()
        section = 'mechanicals'
      }

      if (!categoryName) {
        this.cancelAddCategory()
        return
      }

      if (!this.selectedSchedule.prices) {
        this.$set(this.selectedSchedule, 'prices', {})
      }

      if (!this.selectedSchedule.prices[section]) {
        this.$set(this.selectedSchedule.prices, section, {})
      }

      if (!this.selectedSchedule.prices[section][categoryName]) {
        this.$set(this.selectedSchedule.prices[section], categoryName, [])
      }

      if (this.activeScheduleTab === 'Body Section') {
        this.activeBodyCategory = categoryName
        this.isAddingBodyCategory = false
        this.newBodyCategoryName = ''
      } else if (this.activeScheduleTab === 'Parts' || this.activeScheduleTab === 'Part') {
        this.activePartsCategory = categoryName
        this.isAddingPartsCategory = false
        this.newPartsCategoryName = ''
      } else if (this.activeScheduleTab === 'Sublet') {
        this.activeSubletCategory = categoryName
        this.isAddingSubletCategory = false
        this.newSubletCategoryName = ''
      } else if (this.activeScheduleTab === 'Miscellaneous') {
        this.activeMiscCategory = categoryName
        this.isAddingMiscCategory = false
        this.newMiscCategoryName = ''
      } else if (this.activeScheduleTab === 'Mechanical') {
        this.activeMechanicalCategory = categoryName
        this.isAddingMechanicalCategory = false
        this.newMechanicalCategoryName = ''
      }
    },
    selectCategory (category, type) {
      if (type === 'body') this.activeBodyCategory = category
      else if (type === 'part' || type === '2') this.activePartsCategory = category
      else if (type === 'sublet') this.activeSubletCategory = category
      else if (type === 'misc') this.activeMiscCategory = category
      else if (type === 'mechanical') this.activeMechanicalCategory = category
    },
    getScheduleLineDebounceKey (part, type) {
      return `${type}-${part.id || part.code || part.name || part.lineDescription || JSON.stringify(part)}`
    },
    queueScheduleLineUpdate (part, type) {
      if (!this.selectedSchedule || !this.selectedSchedule.id) return

      const lineKey = this.getScheduleLineDebounceKey(part, type)

      if (this.updateScheduleLineTimers[lineKey]) {
        clearTimeout(this.updateScheduleLineTimers[lineKey])
      }

      this.updateScheduleLineTimers[lineKey] = setTimeout(() => {
        if (part.isSaving) {
          // If the item is currently saving (e.g. waiting for a new ID), delay this update
          this.queueScheduleLineUpdate(part, type)
          return
        }
        this.saveScheduleLine(part, type, lineKey)
      }, 1000)
    },
    saveScheduleLine (part, type, lineKey = null) {
      if (!this.selectedSchedule || !this.selectedSchedule.id) return

      this.$set(part, 'isSaving', true)

      const payload = {
        ...part,
        type
      }

      // Do not send local UI state to the backend
      delete payload.isSaving
      delete payload.isNew

      // Include categoryName based on the type
      if (type === 'body') payload.categoryName = this.activeBodyCategory
      else if (type === 'part' || type === 'parts') payload.categoryName = this.activePartsCategory
      else if (type === 'sublet') payload.categoryName = this.activeSubletCategory
      else if (type === 'misc') payload.categoryName = this.activeMiscCategory
      else if (type === 'mechanical') payload.categoryName = this.activeMechanicalCategory

      // Replace URL with your exact backend endpoint for updating a single schedule line
      Axios.put(`/fe/settings/schedule/${this.selectedSchedule.id}/update-line`, payload)
          .then(response => {
            // Successfully updated
            // Get the item from response data (accommodating if it is wrapped or direct)
            const returnedItem = response.data && response.data.id ? response.data : (response.data && response.data.item ? response.data.item : null)

            if (returnedItem && returnedItem.id) {
              // Immediately update the item with the ID from the backend
              this.$set(part, 'id', returnedItem.id)
              this.$set(part, 'isNew', false)
            }
          })
          .catch(error => {
            console.error('Error updating schedule line:', error)
          })
          .finally(() => {
            part.isSaving = false
            if (lineKey && this.updateScheduleLineTimers[lineKey]) {
              clearTimeout(this.updateScheduleLineTimers[lineKey])
              delete this.updateScheduleLineTimers[lineKey]
            }
          })
    },
    // Changed to open a new window with a GET request for CSV download
    exportScheduleCsv () {
      if (!this.selectedSchedule || !this.selectedSchedule.id) return

      let exportType = ''
      switch (this.activeScheduleTab) {
        case 'Body Section':
          exportType = 'exportBody'
          break
        case 'Parts':
        case 'Part':
          exportType = 'exportParts'
          break
        case 'Sublet':
          exportType = 'exportSublet'
          break
        case 'Miscellaneous':
          exportType = 'exportMisc'
          break
        case 'Mechanical':
          exportType = 'exportMechanical'
          break
      }
      const token = localStorage.getItem('token')
      // const exportUrl = `${appConfig.baseAPIURL || ''}/fe/settings/schedule/${this.selectedSchedule.id}/export-csv/${exportType}?at=${token}`
      const exportUrl = `${appConfig.baseAPIURL || ''}/fe/settings/schedule/${this.selectedSchedule.id}/export-xls?at=${token}`
      window.open(exportUrl, '_blank')
    },
    importScheduleCsv () {
      this.showCsvDropzone = !this.showCsvDropzone
    },
    processingFileUpload (file) {
      if (this.selectedSchedule && this.selectedSchedule.id && this.$refs.fileUpDrop) {
        this.$refs.fileUpDrop.setOption('url', this.csvDropzoneUrl)
      }
    },
    loadSchedulesList () {
      NProgress.start()
      return Axios.get('/fe/settings/schedules')
          .then(response => {
            if (response && response.data && response.data._status) {
              // Assign the fetched schedules to the local state array
              this.schedules = response.data.schedules
            }
          })
          .catch(error => {
            console.error('Error loading schedules:', error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
// Create a new schedule and refresh schedules list after successful response
    createNewSchedule () {
      NProgress.start()

      Axios.post('/fe/settings/schedule/new', {
        name: '',
      })
          .then(response => {
            if (response && response.data && response.data._status) {
              this.$store.dispatch('loadVendorInfo')
              return this.loadSchedulesList()
            }
          })
          .then(() => {
            this.$nextTick(() => {
              const editableSchedules = this.schedules.filter(schedule => Number(schedule.id) > 0)

              if (!editableSchedules.length) {
                return
              }

              const maxId = Math.max(...editableSchedules.map(schedule => Number(schedule.id)))
              const newIndex = this.schedules.findIndex(schedule => Number(schedule.id) === maxId)

              if (newIndex === -1) {
                return
              }

              const refName = 'name-' + newIndex
              const refValue = this.$refs[refName]
              const input = Array.isArray(refValue) ? refValue[0] : refValue

              if (input && typeof input.focus === 'function') {
                input.focus()
                setTimeout(() => {
                  input.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
                  if (typeof input.focus === 'function') {
                    input.focus()
                  }
                  if (typeof input.select === 'function') {
                    input.select()
                  }
                }, 0)
              }
            })
          })
          .catch(error => {
            console.error('Error creating new schedule:', error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    editSchedule (schedule) {
      if (!schedule || !schedule.id || schedule.id < 0) {
        return
      }

      Axios.put(`/fe/settings/schedule/${schedule.id}`, {
        name: schedule.name,
        type: schedule.type,
      })
          .then(response => {
            if (response && response.data && !response.data._status) {
              console.error('Failed to update schedule:', response.data)
            }else if(response?.data?._status){
              this.$store.dispatch('loadVendorInfo')
            }
          })
          .catch(error => {
            console.error('Error updating schedule:', error)
          })
    },
    onTemplateSelect (newVal) {
      if (!this.selectedSchedule) return

      const oldVal = this.selectedSchedule.type || 'dollars'

      if (newVal === oldVal) return

      if (!confirm('Are you sure you want to change the schedule template type?')) {
        this.$nextTick(() => {
          this.selectedScheduleTemplate = oldVal
        })
        return
      }

      this.selectedScheduleTemplate = newVal
      this.selectedSchedule.type = newVal
      this.editSchedule(this.selectedSchedule)
    },
    removeSchedule (schedule) {
      if (!schedule || !schedule.id) return
      const isConfirmed = window.confirm('Are you sure you want to delete this schedule?')
      if (!isConfirmed) return
      NProgress.start()

      Axios.delete(`/fe/settings/schedule/${schedule.id}`)
          .then(response => {
            if (response && response.data && response.data._status) {
              this.loadSchedulesList()
            }
          })
          .catch(error => {
            console.error('Error deleted schedule:', error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    // Fetch and open schedule details
    openSchedule (schedule) {
      if (!schedule || !schedule.id) return
      NProgress.start()

      Axios.get(`/fe/settings/schedule/${schedule.id}`)
          .then(response => {
            if (response && response.data && response.data._status) {
              const scheduleData = response.data.schedule || response.data
              const normalizedPrices = (!scheduleData.prices || Array.isArray(scheduleData.prices))
                  ? { bodies: {}, parts: {}, sublets: {}, miscs: {}, mechanicals: {} }
                  : {
                    ...scheduleData.prices,
                    bodies: Array.isArray(scheduleData.prices.bodies) ? {} : (scheduleData.prices.bodies || {}),
                    parts: Array.isArray(scheduleData.prices.parts) ? {} : (scheduleData.prices.parts || {}),
                    sublets: Array.isArray(scheduleData.prices.sublets) ? {} : (scheduleData.prices.sublets || {}),
                    miscs: Array.isArray(scheduleData.prices.miscs) ? {} : (scheduleData.prices.miscs || {}),
                    mechanicals: Array.isArray(scheduleData.prices.mechanicals) ? {} : (scheduleData.prices.mechanicals || {}),
                  }

              const normalizedSchedule = {
                ...scheduleData,
                prices: normalizedPrices
              }

              this.selectedSchedule = normalizedSchedule

              const categories = Object.keys(normalizedSchedule.prices.bodies)
              this.activeBodyCategory = categories.length > 0 ? categories[0] : null

              const partsCategories = Object.keys(normalizedSchedule.prices.parts)
              this.activePartsCategory = partsCategories.length > 0 ? partsCategories[0] : null

              const subletsCategories = Object.keys(normalizedSchedule.prices.sublets)
              this.activeSubletCategory = subletsCategories.length > 0 ? subletsCategories[0] : null

              const miscsCategories = Object.keys(normalizedSchedule.prices.miscs)
              this.activeMiscCategory = miscsCategories.length > 0 ? miscsCategories[0] : null

              const mechanicalsCategories = Object.keys(normalizedSchedule.prices.mechanicals)
              this.activeMechanicalCategory = mechanicalsCategories.length > 0 ? mechanicalsCategories[0] : null

              this.selectedScheduleTemplate = (normalizedSchedule.type || 'dollars').toLowerCase()
            }
          })
          .catch(error => {
            console.error('Error fetching schedule details:', error)
          })
          .finally(() => {
            NProgress.done()
          })
    },
    addFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].style.display = 'none'
    },
    sendFileUpload (file, xhr, formData) {
      if (file.previewElement) {
        file.previewElement.children[(file.previewElement.children.length - 1)].style.display = 'none'
      }

      let importType = 'importBodyXlsx'
      // switch (this.activeScheduleTab) {
      //   case 'Body Section':
      //     importType = 'importBody'
      //     break
      //   case 'Parts':
      //   case 'Part':
      //     importType = 'importParts'
      //     break
      //   case 'Sublet':
      //     importType = 'importSublet'
      //     break
      //   case 'Miscellaneous':
      //     importType = 'importMisc'
      //     break
      //   case 'Mechanical':
      //     importType = 'importMechanical'
      //     break
      // }

      if (formData) {
        formData.append('type', importType)
      }
    },
    completeFileUpload ($event) {
      $event.previewElement.children[($event.previewElement.children.length - 1)].removeAttribute('style')
    },
    successFileUpload (file, response) {
      if (response && (response.status || response._status)) {
        // Refetch schedule details after successful import
        this.openSchedule(this.selectedSchedule)
        this.showCsvDropzone = false
      }

      var vm = this
      setTimeout(function () {
        if (vm.$refs.fileUpDrop) {
          vm.$refs.fileUpDrop.removeFile(file)
        }
      }, 1000)
    },
    clickCancelDropzoneFiles: function () {
      if (this.$refs.fileUpDrop && this.$refs.fileUpDrop.removeAllFiles) {
        this.$refs.fileUpDrop.removeAllFiles(true)
      }
      this.file_ids = []
    },
    handleNavigation (e) {
      const { key } = e
      const activeElem = document.activeElement
      const tableRowElem = activeElem.closest('.schedule-table-body-elem')
      if (!tableRowElem) {
        return
      }
      const multiContainer = activeElem.closest('.multiselect')
      const isMultiActive = multiContainer && multiContainer.classList.contains('multiselect--active')
      if (isMultiActive && ['ArrowUp', 'ArrowDown', 'Enter'].includes(key)) {
        return
      }

      const curRow = parseInt(activeElem.closest('[data-row]').dataset.row, 10)
      const curCol = parseInt(activeElem.closest('[data-col]').dataset.col, 10)

      let maxRows = 0
      let maxCols = 0
      let minCol = 1

      if (this.activeScheduleTab === 'Sublet') {
        maxRows = this.subletScheduleLines.length - 1
        maxCols = 4
        minCol = 1
      } else if (this.activeScheduleTab === 'Parts' || this.activeScheduleTab === 'Part') {
        maxRows = this.partsScheduleLines.length - 1
        maxCols = 3
        minCol = 1
      } else if (this.activeScheduleTab === 'Miscellaneous') {
        maxRows = this.miscScheduleLines.length - 1
        maxCols = 4
        minCol = 1
      } else if (
          this.activeScheduleTab === 'Body Section' &&
          this.selectedSchedule?.prices?.bodies?.[this.activeBodyCategory]
      ) {
        maxRows = this.selectedSchedule.prices.bodies[this.activeBodyCategory].length - 1
        maxCols = 5
        minCol = 1
      } else if (this.activeScheduleTab === 'Mechanical') {
        maxRows = this.mechanicalScheduleLines.length - 1
        maxCols = 4
        minCol = 1
      }

      let nextRow = curRow
      let nextCol = curCol

      if (['ArrowLeft', 'ArrowRight'].includes(key)) {
        const isInput = activeElem.tagName === 'INPUT' || activeElem.tagName === 'TEXTAREA'
        if (isInput) {
          const cursorPosition = activeElem.selectionStart
          const length = activeElem.value.length

          if ((key === 'ArrowLeft' && cursorPosition > 0) || (key === 'ArrowRight' && cursorPosition < length)) {
            return
          }
          e.preventDefault()
        }
      }

      const isShiftTab = key === 'Tab' && e.shiftKey

      switch (key) {
        case 'ArrowUp':
          e.preventDefault()
          nextRow = Math.max(0, curRow - 1)
          break
        case 'ArrowDown':
          e.preventDefault()
          nextRow = Math.min(maxRows, curRow + 1)
          break
        case 'Enter':
          e.preventDefault()
          this.insertNewItemAfter(curRow)
          return
        case 'ArrowLeft':
          e.preventDefault()
          if (curCol > minCol) {
            nextCol = curCol - 1
          } else if (curRow > 0) {
            nextRow = curRow - 1
            nextCol = maxCols
          }
          break

        case 'Tab':
          e.preventDefault()

          if (isShiftTab) {
            if (curCol > minCol) {
              nextCol = curCol - 1
            } else if (curRow > 0) {
              nextRow = curRow - 1
              nextCol = maxCols
            }
          } else {
            if (curCol < maxCols) {
              nextCol = curCol + 1
            } else if (curRow < maxRows) {
              nextRow = curRow + 1
              nextCol = 1
            }
          }
          break

        case 'ArrowRight':
          e.preventDefault()
          if (curCol < maxCols) {
            nextCol = curCol + 1
          } else if (curRow < maxRows) {
            nextRow = curRow + 1
            nextCol = minCol
          }
          break
      }

      if (nextRow !== curRow || nextCol !== curCol) {
        this.focusElement(nextRow, nextCol)
      }
    },

    focusElement (row, col) {
      let refPref

      if (this.activeScheduleTab === 'Body Section') {
        switch (col) {
          case 1:
            refPref = 'line-'
            break
          case 2:
            refPref = 'code-'
            break
          case 3:
            refPref = 'rr-'
            break
          case 4:
            refPref = 'repair-'
            break
          case 5:
            refPref = 'paint-'
            break
          default:
            return
        }
      } else if (this.activeScheduleTab === 'Parts' || this.activeScheduleTab === 'Part') {
        switch (col) {
          case 1:
            refPref = 'part-description-'
            break
          case 2:
            refPref = 'part-code-'
            break
          case 3:
            refPref = 'part-cost-'
            break
          default:
            return
        }
      } else if (this.activeScheduleTab === 'Sublet') {
        switch (col) {
          case 1:
            refPref = 'description-'
            break
          case 2:
            refPref = 'supplier-'
            break
          case 3:
            refPref = 'code-'
            break
          case 4:
            refPref = 'cost-'
            break
          default:
            return
        }
      } else if (this.activeScheduleTab === 'Miscellaneous') {
        switch (col) {
          case 1:
            refPref = 'misc-description-'
            break
          case 2:
            refPref = 'misc-supplier-'
            break
          case 3:
            refPref = 'misc-code-'
            break
          case 4:
            refPref = 'misc-cost-'
            break
          default:
            return
        }
      } else if (this.activeScheduleTab === 'Mechanical') {
        switch (col) {
          case 1:
            refPref = 'mechanical-description-'
            break
          case 2:
            refPref = 'mechanical-supplier-'
            break
          case 3:
            refPref = 'mechanical-code-'
            break
          case 4:
            refPref = 'mechanical-cost-'
            break
          default:
            return
        }
      } else {
        return
      }

      const refKey = refPref + row
      const refValue = this.$refs[refKey]
      const targetComp = Array.isArray(refValue) ? refValue[0] : refValue

      if (!targetComp) {
        return
      }

      if (typeof targetComp.focus === 'function') {
        targetComp.focus()
      } else if (targetComp.$el) {
        const input = targetComp.$el.querySelector('input, textarea')
        if (input) {
          input.focus()
        }
      } else if (targetComp instanceof HTMLElement) {
        targetComp.focus()
      }
    },
  },
  mounted () {
    this.loadSchedulesList()
  },
}
</script>

<style scoped>
.category-search-wrapper .bx-search-alt {
  position: absolute;
  right: 4px;
  top: 8px;
  font-size: 24px;
  color: rgb(147, 149, 161);
}
.search-filter-schedule{
  height: 39px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  width: 230px;
  border-radius: 3px;
}
.search-filter-schedule .bx-search-alt{
  font-size: 24px;
  margin-top: 7px;
  color: rgb(147, 149, 161);
  margin-left: 7px;
}

.V3 ul.nav.nav-4 {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  margin-right: 10px;
  scrollbar-width: thin;
}

.V3 ul.nav.nav-4 li {
  position: relative;
}

.V3 ul.nav.nav-4 .nav-item.active {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 ul.nav.nav-4 .nav-item.active a:focus {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 ul.nav.nav-4 .nav-item.active .nav-link {
  color: #5E79FF;
}

.V3 ul.nav.nav-4 .nav-item.active::after {
  content: "";
  position: absolute;
  left: 0px;
  bottom: 0px;
  height: 100%;
  width: 5px;
  border-radius: 0 5px 5px 0;
  background-color: #5E79FF;
}

.V3 ul.nav.nav-4 .nav-item .nav-link {
  font-weight: 700;
  color: black;
  padding-top: 8px;
  padding-bottom: 8px;
}

.V3 ul.nav.nav-4 .nav-item .nav-link:hover {
  background-color: rgba(94, 121, 255, 0.1) !important;
}

.V3 .search-input {
  background: url('data:image/svg+xml;base64,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') no-repeat center right;
  background-position: right 7px center;
}

.btn-back {
  margin-right: 20px;
  padding: 2px 8px;
  border-radius: 3px;
  border-color: #5e79ff;
  color: white;
  background-color: #5e79ff;
  font-size: 12px;
  height: 31px;
  position: relative;
  bottom: 7.5px;
}

.btn-back .bx-arrow-back {
  font-size: 15px;
  position: relative;
  bottom: 2px;
}

.btn-back:hover {
  color: white;
  background-color: #7189ff;
}

.V3 .vue-dropzone-block .dropzoneContainer {
  margin: 5px 15px;
  width: auto;
  border: 3px solid #5E79FF;
  border-radius: 3px;
  background: white !important;
  min-width: 125px;
}

.V3 .vue-dropzone-block .dropify-wrapper .dropify-message span.file-icon:before {
  content: '\E800';
  font-weight: 800;
  font-size: 37px;
  color: #5E79FF;
}

.V3 .vue-dropzone-block .dropify-wrapper .dropify-message .dnd-title {
  font-family: "Nunito Sans";
  color: #1C1F39;
  font-size: 13px;
  font-weight: bold;
}

.V3 .vue-dropzone-block .bx {
  font-size: 37px;
  color: #5E79FF;
}

.V3 .vue-dropzone-block .text-or {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-weight: 700;
  opacity: 0.25;
  font-size: 13px;
}

.V3 .vue-dropzone-block >>> .dz-message {
  margin: 0;
}


.market-place-item {
  border: 2px solid #c7c7c7;
  padding: 10px 15px;
  border-radius: 4px;
  margin-top: 10px;
}

.market-place-item .market-place-item-name {
  font-size: 17px;
  color: #363636;
 /* text-transform: uppercase;  //sometimes we need add opportunity for add a small word in the item name */
  font-weight: 700;
  margin-bottom: 10px;
}

.market-place-item .market-place-item-cost {
  font-size: 15px;
  color: #4673c3;
  font-weight: 700;
  margin-bottom: 10px;
}

.market-place-item .bxs-star,
.market-place-item .bxs-star-half,
.market-place-item .bx-star {
  font-size: 22px;
}

.market-place-item .bxs-star,
.market-place-item .bxs-star-half {
  color: #d09400;
}

.market-place-item .bx-star {
  color: #9b9b9b;
}

.description-text {
  padding-top: 10px;
  color: rgba(0, 0, 0, 0.5);
}

.schedule-table {
  height: calc(100vh - 490px);
  overflow-y: auto;
  scrollbar-width: thin;
}
.search-filter-schedule-management >>> .overlay{
  height: calc(100vh - 490px);
}

.schedule-table-header {
  height: 48px;
  color: #1C1F39 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: #e6e6e9;
}

.schedule-table-header-item {
  padding-left: 6px;
}

.schedule-table-body-item {
  padding: 4px 2px;
}

.schedule-table-body-elem {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid rgba(27, 30, 56, .25);
}

.schedule-table-body-elem:hover {
  background-color: #edeffd !important;
}

.schedule-table-body-elem .form-control {
  padding: .5rem .15rem;
 /* text-transform: uppercase; */
}

.schedule-table-body-elem .numeric {
  text-align: right;
}

.schedule-header-category,
.schedule-body-category {
  width: 170px;
}

.schedule-header-line,
.schedule-body-line {
  flex: 1 1 auto;
  min-width: 260px;
}

.schedule-header-code,
.schedule-body-code {
  width: 95px;
}

.schedule-header-paint,
.schedule-body-paint,
.schedule-header-repair,
.schedule-body-repair,
.schedule-header-rr,
.schedule-body-rr {
  width: 64px;
}

.schedule-header-cost,
.schedule-body-cost {
  width: 64px;
}

.schedule-header-supplier,
.schedule-body-supplier {
  width: 150px;
}

.schedule-table-header-item {
  padding-left: 10px;
}

.schedule-header-trush,
.schedule-body-trush {
  width: 50px;
  padding-left: 20px;
}

.schedule-management-toolbar {
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.schedule-management-tabs {
  display: flex;
  gap: 4px;
}

.schedule-management-tab {
  padding: 6px 12px;
  border: none;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  color: #4d4d4d;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  background: transparent;
  box-shadow: none;
}

.schedule-management-tab.active {
  color: rgb(94, 121, 255);
  border-bottom-color: rgb(94, 121, 255);
}

.schedule-management-actions {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  position: absolute;
  right: 15px;
  top: 5px;
}

.schedule-management-select {
  min-width: 125px;
  position: relative;
  z-index: 20;
}

.schedule-action-btn {
  min-width: 95px;
  text-transform: uppercase;
  background-color: white;
}

.tab-header-orders.active {
  background: linear-gradient(135deg, rgb(114, 103, 231) 0%, rgb(98, 89, 239) 49.12%, rgb(78, 69, 238) 100%);
  color: #f8f8f8;
}

.tab-header-orders {
  border: 1px solid rgb(94, 121, 255);
  color: rgb(94, 121, 255);
  font-weight: bold;
}

.schedule-management-select >>> .multiselect {
  min-height: 38px;
  position: relative;
  z-index: 20;
}

.schedule-management-select >>> .multiselect__tags {
  min-height: 38px;
  border: 1px solid rgb(94, 121, 255);
  border-radius: 2px;
  padding: 8px 30px 0 12px;
}

.schedule-management-select >>> .multiselect__single {
  margin-bottom: 8px;
  color: rgb(94, 121, 255);
  font-size: 12px;
  font-weight: 700;
}

.schedule-management-select >>> .multiselect__select:before {
  color: rgb(94, 121, 255);
  border-color: rgb(94, 121, 255) transparent transparent;
}

.schedule-management-select >>> .multiselect__content-wrapper {
  border-color: rgb(94, 121, 255);
  z-index: 30;
}

.tabs-component-tab {
  cursor: pointer;
}

.schedule-table-body >>> .ghost-items {
  display: block;
}

.schedule-body-table {
  flex: 1;
  min-width: 0;
  overflow-x: auto;
}

@media screen and (min-width: 768px) {
  .V3 .vh-height-65,
  .schedule-table {
    height: calc(100vh - 636px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .schedule-table {
    height: calc(100vh - 540px);
  }
  .search-filter-schedule-management >>> .overlay{
    height: calc(100vh - 636px);
  }
}

@media screen and (min-width: 991px) {
  .V3 .vh-height-65,
  .schedule-table {
    height: calc(100vh - 596px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .schedule-table {
    height: calc(100vh - 500px);
  }
  .search-filter-schedule-management >>> .overlay{
    height: calc(100vh - 596px);
  }
}

@media screen and (min-width: 1024px) {
  .V3 .vh-height-65,
  .schedule-table {
    height: calc(100vh - 656px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .schedule-table {
    height: calc(100vh - 560px);
  }
  .search-filter-schedule-management >>> .overlay{
    height: calc(100vh - 656px);
  }
}

@media screen and (min-width: 1300px) {
  .V3 .vh-height-65,
  .schedule-table {
    height: calc(100vh - 655px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .schedule-table {
    height: calc(100vh - 561px);
  }
  .search-filter-schedule-management >>> .overlay{
    height: calc(100vh - 655px);
  }
}

@media screen and (min-width: 1820px) {
  .V3 .vh-height-65,
  .schedule-table {
    height: calc(100vh - 605px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  .schedule-table {
    height: calc(100vh - 509px);
  }
  .search-filter-schedule-management >>> .overlay{
    height: calc(100vh - 605px);
  }
}

.schedule-table-body-elem {
  display: flex;
  align-items: center;
}

.schedule-drag-handle {
  cursor: grab;
}

.schedule-drag-handle:active {
  cursor: grabbing;
}

.schedule-body-dragging,
.schedule-body-dragging .schedule-table-body,
.schedule-body-dragging .schedule-table-body * {
  cursor: grabbing;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

/* Sidebar and container styling */
.category-sidebar {
  width: 260px;
  min-width: 260px;
  margin-right: 15px;
}

.category-list-container {
  background: #fff;
  border: 1px solid #5E79FF; /* Changed to match input border */
  border-radius: 4px;
  overflow: hidden;
}

/* Search bar styling */
.category-search-wrapper {
  position: relative;
  border-bottom: 1px solid #8e9094;
}

.category-search-input {
  width: 100%;
  height: 39px;
  padding: 0 40px 0 16px;
  border: none;
  outline: none;
  font-size: 14px;
  color: #333;
  background: transparent;
}

.search-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 16px;
}

/* List and items styling */
.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
  overflow-y: auto;
}

.category-item {
  border-bottom: 1px solid #e5e7eb;
}

.category-item:last-child {
  border-bottom: none;
}

.category-link {
  /* We add relative positioning here so the active indicator can be placed inside */
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  text-decoration: none;
  color: #000000; /* Darker black text for inactive items */
  font-weight: 700; /* Updated to 700 based on the screenshot style */
  font-size: 14px;
  transition: all 0.2s ease;
}

.category-link:hover {
  background-color: #5E79FF1A;
}

/* Active item styling */
.category-item.active .category-link {
  background-color: #5E79FF1A;
  color: #5E79FF; /* Updated to use the exact color from the screenshot */
}

/* We use a pseudo-element to create the rounded left blue border (pill shape) */
.category-item.active .category-link::before {
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  bottom: 6px;
  width: 5px;
  background-color: #5E79FF; /* Updated to use the exact color from the screenshot */
  border-radius: 0 4px 4px 0; /* Rounds the right side of the border */
}

/* Align add category input with normal menu items */
.add-category-input {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px; /* Matches category-link padding */
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 700; /* Bold font like normal items */
  color: #000000; /* Black text */
  background-color: #ffffff; /* White background */
}

/* Optional: Make the placeholder text lighter so it doesn't look like a saved item yet */
.add-category-input::placeholder {
  font-weight: 400;
  color: #9ca3af;
}
</style>
